import { SendGridDroppedUnsubscribeProcessingId } from '@deltasierra/ids';
import { Brand, createBranded } from '@deltasierra/type-utilities';
import { HasId } from '../../../common';
import { LocationId } from '../../../location';
import { EmailEventSource } from '../../email-event-source.enum';

export type OptOutEmailId = Brand<number, 'optoutemail'>;
export const OptOutEmailId = createBranded<OptOutEmailId>();

export enum OptOutEmailsUpdatedCrmStatus {
    errored = 'errored', // Errored when attempting to updat/check CRM outside event handler (e.g. user not found)
    failed = 'failed', // CRM Update failed in event handler
    mismatched = 'mismatched', // Record in OptOutEmail table does not match CRM
    succeeded = 'succeeded', // CRM updated successfully and record matches CRM
    unknown = 'unknown', // Update/check against CRM has not been carried out
}

export interface OptOutEmail extends HasId<OptOutEmailId> {
    createdAt?: Date;
    deletedAt?: Date | null;
    droppedUnsubscribeProcessingId: SendGridDroppedUnsubscribeProcessingId | null;
    email: string;
    event: Record<keyof never, unknown>;
    isUnsubscribed: boolean;
    locationId: LocationId;
    singleSendId: string;
    source?: EmailEventSource;
    unsubscribeGroupId?: number | null;
    updatedAt?: Date;
    updatedCrmAt?: Date | null;
    updatedCrmStatus: OptOutEmailsUpdatedCrmStatus;
}

export type OptOutEmailUpsertInput = Pick<
    OptOutEmail,
    | 'droppedUnsubscribeProcessingId'
    | 'email'
    | 'event'
    | 'isUnsubscribed'
    | 'locationId'
    | 'singleSendId'
    | 'unsubscribeGroupId'
    | 'updatedCrmAt'
    | 'updatedCrmStatus'
> &
    // Required so upserts always overwrite the provenance of an existing row instead of leaving a stale value.
    Required<Pick<OptOutEmail, 'source'>>;
